import { type AnalyticsProperties } from '../../../services/analytics'
import { type GlobalSearchResultItem, type GlobalSearchActionUI } from '../global-search-models'

export interface GlobalSearchAnalyticsProperties {
  readonly searchString: string
  readonly eventName: string
  readonly eventType: string
  readonly searchResult?: GlobalSearchResultItem
  readonly action?: GlobalSearchActionUI
  readonly properties: AnalyticsProperties
}

export enum SearchStringPropertyValue {
  ALL = 'all',
  SOME = 'some',
  NONE = 'none',
  TRUE = 'true',
  POSSIBLE = 'possible',
  FALSE = 'false',
}

export interface AnalyticsActionProperty {
  readonly actionID: string
  readonly commandName: string
  readonly commandNamespace: string
}

export interface AnalyticsResultItemProperty {
  readonly application: string
  readonly score: number
}
